export const STRINGS = {
  SECURITY_PRIORITY_MESSAGE:
    "Your school's security is our top priority. Please enable Multi-Factor Authentication to help keep your information safe.",
  MFA_SETUP_LINK: 'Click here to setup MFA',
};
